import { type ReactNode } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, whatsappLink } from "@/constants/site";
import { supportChannels } from "@/mocks/suporte";

export default function SupportChannels() {
  function renderAction(action: string, value: string): ReactNode {
    if (action === "whatsapp") {
      return (
        <a
          href={whatsappLink("Ola! Preciso de suporte da NXHOST.")}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          {WHATSAPP_DISPLAY}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      );
    }

    if (action === "email") {
      return (
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          {CONTACT_EMAIL}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      );
    }

    return (
      <Link
        to="/contato"
        className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
      >
        {value}
        <i className="ri-arrow-right-line" aria-hidden="true"></i>
      </Link>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {supportChannels.map((channel, index) => (
        <Reveal key={channel.title} delay={index * 70} className="h-full">
          <article className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100/70 text-primary-700">
              <i className={`${channel.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
              {channel.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
              {channel.description}
            </p>
            <div className="mt-5 border-t border-background-200 pt-4">
              {renderAction(channel.action, channel.value)}
            </div>
          </article>
        </Reveal>
      ))}
    </div>
  );
}